import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import SoftBox from "components/SoftBox";
import { Icon } from "@mui/material";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";

function SubCategoryPopup({ item, open, onClose, handleRefresh }) {
    const AppService = useAppServices();
    const [agency, Update] = useAgencyInfo();
    const [waitingAdd, setWaitingAdd] = useState(false);
    const [waitingSave, setWaitingSave] = useState(false);
    const [newSubCategory, setNewSubCategory] = useState({ id: "", name: "" });
    const [selectedSubs, setSelectedSubs] = useState([]);

    useEffect(() => {
        if (agency?.SubCategories) {
            setSelectedSubs([]);
        }
    }, [agency?.SubCategories]);

    const handleCreateSubCategory = async (e) => {
        e.preventDefault();
        if (!newSubCategory.name) return;

        setWaitingAdd(true);

        // Include agency_id in the new subcategory
        const subCategoryWithAgencyId = {
            ...newSubCategory,
            agency_id: agency._id
        };

        const payload = {
            _id: agency._id,
            SubCategories: [...(agency?.SubCategories || []), subCategoryWithAgencyId],
        };

        const updatedAgency = await AppService.agency.update({ payload, toaster: true });
        if (updatedAgency) {
            setNewSubCategory({ id: "", name: "" });
            // handleRefresh();
            console.log(updatedAgency, 'updatedAgency')
            Update(updatedAgency?.response?.data);

        }
        setWaitingAdd(false);
    };

    const handleSubmitSelection = async (e) => {
        e.preventDefault();
        setWaitingSave(true);

        // Add agency_id to selected subcategories
        const subCategoriesWithAgencyId = selectedSubs.map(sub => ({
            ...sub,
            agency_id: agency._id
        }));

        const payload = {
            _id: item._id,
            subCategory: subCategoriesWithAgencyId,
        };

        const updatedAgency = await AppService.assistant.update({ payload, toaster: true });
        if (updatedAgency) {
            handleRefresh();
            onClose();
        }
        setWaitingSave(false);
    };

    useEffect(() => {
        if (agency?.SubCategories && item?.subCategory) {
            // Filter only those subcategories from agency list that exist in item.subCategory
            // and belong to current agency
            const existingSelected = agency.SubCategories
                .filter(sub => !sub.agency_id || sub.agency_id === agency._id) // Only current agency's subcategories
                .filter(sub => item.subCategory.some(selected => selected.id === sub.id));
            setSelectedSubs(existingSelected);
        }
    }, [agency?.SubCategories, item?.subCategory, agency._id]);

    const updateAgencyCategories = async (updatedCategories) => {
        const payload = {
            _id: agency._id,
            SubCategories: updatedCategories,
        };

        try {
            const { response } = await AppService.agency.update({
                payload,
                toaster: true,
            });
            if (response) {
                Update(response.data);
            }
            // handleRefresh()
        } catch (error) {
            console.log('An error occurred');
        }
    };

    const handleDelete = (id) => {
        const updatedCategories = agency?.SubCategories.filter(cat => cat.id !== id);
        updateAgencyCategories(updatedCategories);
    };

    return (
        <>
            {open && (
                <div className="modal-zz-confirm text-left">
                    <div className="p-2 scrollable-modal-content bg-white rounded" style={{ position: "relative" }}>
                        <h2 className="text-black text-left font-14" style={{ fontWeight: "700", marginBottom: "10px" }}>
                            Manage Tags
                        </h2>
                        <span className="crossison" onClick={onClose}>
                            X
                        </span>

                        {/* Existing SubCategories with Checkboxes */}
                        <div style={{ display: "flex", flexDirection: "column", gap: "10px", height: "200px", overflowY: "auto" }}>
                            {agency?.SubCategories
                                ?.filter(sub => sub.agency_id === agency._id) // Show only current agency's subcategories
                                ?.map((sub, index) => (
                                    <label key={index} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px", border: "1px solid #ccc", borderRadius: "5px" }}>
                                        <span style={{ display: "flex", alignItems: "center", gap: "8px", height: '20px' }}>
                                            <input
                                                type="checkbox"
                                                checked={selectedSubs.some((s) => s.id === sub.id)}
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        // Add agency_id when selecting subcategory
                                                        const subWithAgencyId = { ...sub, agency_id: agency._id };
                                                        setSelectedSubs([...selectedSubs, subWithAgencyId]);
                                                    } else {
                                                        setSelectedSubs(selectedSubs.filter((s) => s.id !== sub.id));
                                                    }
                                                }}
                                            />
                                            {sub.name}
                                        </span>

                                        <p className="cursor-pointer" onClick={() => handleDelete(sub.id)} ><Icon>delete</Icon></p>
                                    </label>
                                ))}
                        </div>                        {/* New SubCategory Form */}
                        <SoftBox component="form" onSubmit={handleCreateSubCategory} mt={2} mb={2}>
                            <input
                                placeholder="New Tag Name"
                                style={{ width: "100%", padding: "8px", marginBottom: "8px", borderRadius: '5px' }}
                                value={newSubCategory.name}
                                onChange={(e) => setNewSubCategory({ id: Date.now().toString(), name: e.target.value })}
                                disabled={waitingAdd}
                            />
                            <button
                                style={{ background: 'white', color: 'black', border: '1px solid #ccc', padding: '10px 16px', borderRadius: '5px', opacity: waitingAdd ? 0.6 : 1, cursor: waitingAdd ? 'not-allowed' : 'pointer' }}
                                className=" w-100"
                                type="submit"
                                disabled={waitingAdd || !newSubCategory.name}
                            >
                                {waitingAdd ? (
                                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <span className="spinner" style={{ width: '16px', height: '16px', marginRight: '8px' }}></span> Adding...
                                    </span>
                                ) : "Add Tag"}
                            </button>
                        </SoftBox>

                        {/* Final Submit */}
                        <SoftBox mt={2}>
                            <button
                                className="savebtn-setting w-100"
                                type="button"
                                disabled={waitingSave}
                                onClick={handleSubmitSelection}
                                style={{ opacity: waitingSave ? 0.6 : 1, cursor: waitingSave ? 'not-allowed' : 'pointer' }}
                            >
                                {waitingSave ? (
                                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <span className="spinner" style={{ width: '16px', height: '16px', marginRight: '8px' }}></span> Saving...
                                    </span>
                                ) : "Save Tags"}
                            </button>
                        </SoftBox>
                    </div>
                </div>
            )}
        </>
    );
}

SubCategoryPopup.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    handleRefresh: PropTypes.func.isRequired,
    item: PropTypes.object.isRequired,
};

function AddSubCategory({ handleRefresh, item }) {
    const [open, setOpen] = useState(false);

    return (
        <>
            <span
                style={{ cursor: 'pointer' }}
                onClick={() => setOpen(true)}
            >
                <Icon>edit</Icon>
            </span>

            <SubCategoryPopup item={item} open={open} onClose={() => setOpen(false)} handleRefresh={handleRefresh} />
        </>
    );
}

AddSubCategory.propTypes = {
    handleRefresh: PropTypes.func.isRequired,
};

export default AddSubCategory;
